export var COOKIES_COMPASS_THEME_KEY = '__creh_compass_theme';